export default __webpack_public_path__ + "static/media/B651.ecdf0e69.webp";